module.exports = __webpack_public_path__ + "29ab7a295b800ac8cdee51c9f16a9384.svg";